import type { UserProfile as BaseUserProfile } from '@nvision/oidc';
import { v4 as uuidv4 } from 'uuid';

interface UserProfile extends Omit<BaseUserProfile, 'userType'> {
  id: number;
  applicationID: number;
  userGuid: string;
  userType: 'CARR' | 'VEND' | 'CUST';
}

export const normalizeUserData = (profileData: BaseUserProfile): UserProfile | undefined => {
  // NOTE: This function is a temporary bridge for legacy authentication.
  // Once the old authentication system is fully deprecated, remove normalizeUserData.
  // and update logic based on userType applicationID  and userGuid
  if (!profileData) {
    return undefined;
  }

  const userTypes = {
    carrier: 'CARR',
    customer: 'CUST',
    vendor: 'VEND',
  } as const;

  return {
    ...profileData,
    id: Number(profileData.sub),
    applicationID: Number(profileData.ApplicationID),
    userType: userTypes[profileData.userType],
    userGuid: uuidv4(),
  };
};
